export class Diagnosticable {
  //TODO
}
